import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const EvidenceHistory = lazy(() => import('./EvidenceHistory.jsx'))

const EvidenceHistoryRoutes = [
    {
        path: '/EvidenceHistory',
        component: EvidenceHistory,
        auth: authRoleAccess.case_evidence_history,
    },
   
]

export default EvidenceHistoryRoutes